const SideBar = function () {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.selectedTabId = $ctrl.initialSelection;
  };

  $ctrl.tabSelected = function (id) {
    $ctrl.selectedTabId = id;
    $ctrl.onSelect({tabId: id});
  }
};

export default {
  name: 'sideBar',
  obj: {
    controller: SideBar,
    templateUrl: 'components/side_bar.html',
    bindings: {
      title: '<',
      tabs: '<',
      actions: '<',
      initialSelection: '<',
      onSelect: '&'
    }
  },
  deps: []
}